<template>
  <div>
    <div class="row" v-if="windowType === 'regular'">
      <div class="col-md-3 col-date-line-item">
        <input
            id="kobitest123"
            ref="kobitest123"
          type="date"
          class="form-control date-line-item"
          placeholder="First name"
          v-model="taskDate.startDate"
          @change="changeEndTime($event)"
          @click="calendarTabIsActive()"
          :readonly="true"
          :style="selectedEditorTab == 'CAL' ? { background: 'white' } : null"
          :class="{
            frozen: disableTimeFrame(task)
          }"
        />
      </div>
      <div
        class="col-md-2 col-date-line-item"
        :class="{
          frozen:
            estimatedTime == 'OUTLINE' ||
            estimatedTime == 'ANNOUNCEMENT' ||
            estimatedTime == 'OPEN SHIFT' ||
            estimatedTime == 'COMP. EVENT' ||
            ifTimeFrameDisabled
        }"
      >
        <vue-timepicker
          class="time-line-item"
          manual-input
          @input="onInput"
          :minute-interval="1"
          v-model="taskDate.startTime"
          input-width="65px"
          :id="taskStartTime"
        />
      </div>
      <div
        class="col-md-3 col-date-line-item col-select-line-item"
        :class="{
          ifTimeFrameDisabled
        }"
      >
        <div
          class="btn-group select-line-item dropup"
          :class="{
            frozen: disableTimeFrame(task)
          }"
        >
          <button
            type="button"
            class="btn btn-primary dropdown-toggle dropdown-toggle-split estimated-time-button date-rep-button"
            data-toggle="dropdown"
          >
            {{ estimatedTime }}{{ " " }}
            <!--            <span-->
            <!--              v-if="-->
            <!--                selectedRepeatOption.repeatId !== 8 &&-->
            <!--                  selectedRepeatOption.repeatId !== 9-->
            <!--              "-->
            <!--              >{{ selectedRepeatOption.name }}</span-->
            <!--            >-->
          </button>
          <div class="dropdown-menu">
            <div class="list-group">
              <div
                class="list-group-item list-group-item-action option-container"
                v-for="(item, idx) in estTimes"
                v-bind:key="item.title"
                @mouseover="
                  hover = true;
                  hoverCellId = idx;
                "
                @mouseleave="
                  hover = false;
                  hoverCellId = idx;
                "
              >
                <a
                  href="#"
                  class="list-group-item list-group-item-action linked"
                  v-on:click.prevent="changeEstTime($event, idx)"
                  >{{ item.title }}
                </a>

                <!--                <div-->
                <!--                  class="repeat-options"-->
                <!--                  v-if="-->
                <!--                    item.title != 'OUTLINE' &&-->
                <!--                      item.title != 'OPEN SHIFT' &&-->
                <!--                      item.title != 'ANNOUNCEMENT'-->
                <!--                  "-->
                <!--                >-->
                <!--                  <div-->
                <!--                    class="repeat-options"-->
                <!--                    v-if="idx !== 0 && repeat.id !== 8 && repeat.id !== 9"-->
                <!--                    v-for="repeat in repeatTypeOptions"-->
                <!--                    v-bind:key="repeat.id"-->
                <!--                    :style="-->
                <!--                      (hover && hoverCellId === idx) ||-->
                <!--                      selectedRepeatOption.rangeId === idx-->
                <!--                        ? { display: 'flex', alignItems: 'flex-end' }-->
                <!--                        : { display: 'none' }-->
                <!--                    "-->
                <!--                  >-->
                <!--                    <input-->
                <!--                      type="checkbox"-->
                <!--                      class="item-checkbox"-->
                <!--                      :id="repeat.id"-->
                <!--                      :checked="-->
                <!--                        selectedRepeatOption.name === repeat.title &&-->
                <!--                          selectedRepeatOption.rangeId === idx &&-->
                <!--                          selectedRepeatOption.alias === repeat.type-->
                <!--                      "-->
                <!--                      @change.prevent="-->
                <!--                        selectRepeatOption(-->
                <!--                          repeat.title,-->
                <!--                          idx,-->
                <!--                          repeat.type,-->
                <!--                          item.title,-->
                <!--                          $event,-->
                <!--                          repeat.id-->
                <!--                        )-->
                <!--                      "-->
                <!--                      :value="repeat.title"-->
                <!--                    />-->
                <!--                    <div-->
                <!--                      class="item-text"-->
                <!--                      :title="repeat.name"-->
                <!--                      :for="repeat.id"-->
                <!--                      :style="-->
                <!--                        selectedRepeatOption.alias === repeat.type-->
                <!--                          ? { fontWeight: 'bold' }-->
                <!--                          : { fontWeight: 'normal' }-->
                <!--                      "-->
                <!--                    >-->
                <!--                      {{ " " }}{{ repeat.title }}{{ " " }}-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-md-3 col-date-line-item"
        :class="{
          frozen:
            estimatedTime == 'OUTLINE' ||
            estimatedTime == 'ANNOUNCEMENT' ||
            estimatedTime == 'OPEN SHIFT' ||
            estimatedTime == 'QUESTION' ||
            ifTimeFrameDisabled
        }"
      >
        <input
          type="date"
          class="form-control date-line-item"
          placeholder="First name"
          v-model="taskDate.endDate"
          :readonly="true"
          @click="calendarTabIsActive()"
          :style="selectedEditorTab == 'CAL' ? { background: 'white' } : null"
        />

      </div>
      <div
        class="col-md-2 col-date-line-item"
        :class="{
          frozen:
            estimatedTime == 'OUTLINE' ||
            estimatedTime == 'ANNOUNCEMENT' ||
            estimatedTime == 'OPEN SHIFT' ||
            estimatedTime == 'QUESTION' ||
            ifTimeFrameDisabled
        }"
      >
        <vue-timepicker
          class="time-line-item"
          manual-input
          @input="onInput"
          :minute-interval="1"
          input-width="65px"
          :id="taskEndTime"
          v-model="taskDate.endTime"
        />
      </div>
    </div>
    <div class="row date-time-short-row" v-if="windowType === 'mini'">
      <div class="col-sm-3 mini-date-col mini-date-col-start">
        <input
          type="date"
          class="form-control mini-task-date-input"
          v-model="taskDate.startDate"
          @change="changeEndTime($event)"
          @click="calendarTabIsActive()"
          :readonly="true"
          :style="selectedEditorTab == 'CAL' ? { background: 'white' } : null"
        />
      </div>
      <div class="col-sm-2 mini-date-col">
        <vue-timepicker
          class="time-line-item"
          manual-input
          @input="onInput"
          :minute-interval="1"
          v-model="taskDate.startTime"
          input-width="65px"
          :id="taskStartTime"
        />
      </div>

      <div class="col-sm-3 mini-date-col mini-date-col-est">
        <div class="btn-group select-line-item dropup">
          <button
            type="button"
            class="btn btn-primary dropdown-toggle dropdown-toggle-split estimated-time-button date-rep-button"
            data-toggle="dropdown"
          >
            {{ estimatedTime }}{{ " " }}{{ selectedRepeatOption.name }}>>>
          </button>
          <div class="dropdown-menu">
            <div class="list-group">
              <div
                class="list-group-item list-group-item-action option-container"
                v-for="(item, idx) in estTimes"
                v-bind:key="item.title"
                @mouseover="
                  hover = true;
                  hoverCellId = idx;
                "
                @mouseleave="
                  hover = false;
                  hoverCellId = idx;
                "
              >
                <a
                  href="#"
                  class="list-group-item list-group-item-action linked"
                  v-on:click.prevent="changeEstTime($event, idx)"
                  >{{ item.title }}
                </a>
                <div
                  class="repeat-options"
                  v-if="
                    item.title != 'OUTLINE' &&
                      item.title != 'OPEN SHIFT' &&
                      item.title != 'ANNOUNCEMENT'
                  "
                >
                  <div
                    class="repeat-options"
                    v-if="idx !== 0"
                    v-for="repeat in repeatTypeOptions"
                    v-bind:key="repeat.id"
                    :style="
                      (hover && hoverCellId === idx) ||
                      selectedRepeatOption.rangeId === idx
                        ? { display: 'flex', alignItems: 'flex-end' }
                        : { display: 'none' }
                    "
                  >
                    <input
                      type="checkbox"
                      class="item-checkbox"
                      :id="repeat.id"
                      :checked="
                        selectedRepeatOption.name === repeat.title &&
                          selectedRepeatOption.rangeId === idx &&
                          selectedRepeatOption.alias === repeat.type
                      "
                      @change.prevent="
                        selectRepeatOption(
                          repeat.title,
                          idx,
                          repeat.type,
                          item.title,
                          $event,
                          repeat.id
                        )
                      "
                      :value="repeat.title"
                    />
                    <div
                      class="item-text"
                      :title="repeat.name"
                      :for="repeat.id"
                      :style="
                        selectedRepeatOption.alias === repeat.type
                          ? { fontWeight: 'bold' }
                          : { fontWeight: 'normal' }
                      "
                    >
                      {{ " " }}{{ repeat.title }}{{ " " }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3 mini-date-col mini-date-col-end">
        <input
          type="date"
          class="form-control mini-task-date-input"
          v-model="taskDate.endDate"
          :readonly="true"
          @click="calendarTabIsActive()"
          :style="selectedEditorTab == 'CAL' ? { background: 'white' } : null"
        />
      </div>
      <div class="col-sm-2 mini-date-col">
        <vue-timepicker
          class="time-line-item"
          manual-input
          @input="onInput"
          :minute-interval="1"
          input-width="65px"
          :id="taskEndTime"
          v-model="taskDate.endTime"
        />
      </div>
      <div class="col-sm-2">

      </div>
    </div>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import moment from "moment/moment";
import {mapGetters, mapState} from "vuex";

export default {
  name: "TaskDateTime",
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  components: {
    VueTimepicker
  },
  props: {
    taskSubType: {
      type: Object,
      required: true
    },
    taskType: {
      type: Object,
      required: true
    },
    ifTimeFrameDisabled: {
      type: Boolean
    },
    changeEstTimeTitle: {
      type: String
    },
    repeatTypeOptions: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    taskDate: {
      type: Object,
      required: true
    },
    selectedEditorTab: {
      type: String,
      required: true
    },
    windowType: {
      type: String,
      default() {
        return "regular";
      }
    }
  },
  data() {
    return {
      // taskDate: {
      //   // startDate: moment().format("YYYY-MM-DD"),
      //   startDate: this.task
      //     ? moment(this.task.start_time).format("YYYY-MM-DD")
      //     : moment().format("YYYY-MM-DD"),
      //   endDate: this.task
      //     ? moment(this.task.end_time).format("YYYY-MM-DD")
      //     : moment().format("YYYY-MM-DD"),
      //   startTime: this.task
      //     ? this.getTimeFromTask(this.task.start_time)
      //     : this.getStartTime(),
      //   endTime: this.task
      //     ? this.getTimeFromTask(this.task.end_time)
      //     : this.getEndTime()
      // },
      estimatedTime: "3 hours",
      // estTimes: [
      //   { title: "0 minutes" },
      //   { title: "15 minutes" },
      //   { title: "30 minutes" },
      //   { title: "1 hour" },
      //   { title: "2 hours" },
      //   { title: "3 hours" },
      //   { title: "6 hours" },
      //   { title: "9 hours" },
      //   { title: "12 hours" },
      //   { title: "15 hours" },
      //   { title: "1 day" },
      //   { title: "2 days" },
      //   { title: "3 days" },
      //   { title: "week" },
      //   { title: "2 weeks" },
      //   { title: "month" },
      //   { title: "2 month" },
      //   { title: "3 month" },
      //   { title: "Half a year" },
      //   { title: "9 month" },
      //   { title: "Year" },
      //   { title: "Year and half" },
      //   { title: "2 years" },
      //   { title: "3 years" },
      //   { title: "5 years" }
      // ],
      estTimes: [
        { title: "5 years" },
        { title: "3 years" },
        { title: "2 years" },
        { title: "Year and half" },
        { title: "Year" },
        { title: "9 month" },
        { title: "Half a year" },
        { title: "3 month" },
        { title: "2 month" },
        { title: "month" },
        { title: "2 weeks" },
        { title: "week" },
        { title: "3 days" },
        { title: "2 days" },
        { title: "1 day" },
        { title: "15 hours" },
        { title: "12 hours" },
        { title: "9 hours" },
        { title: "6 hours" },
        { title: "3 hours" },
        { title: "2 hours" },
        { title: "1 hour" },
        { title: "30 minutes" },
        { title: "15 minutes" },
        { title: "OUTLINE" },
        { title: "COMP. EVENT" },
        { title: "OPEN SHIFT" },
        { title: "ANNOUNCEMENT" },
        { title: "QUESTION" }
      ],
      repeatOptions: [
        {
          id: 1,
          name: "Once",
          alias: "ONCE"
        },
        {
          id: 2,
          name: "Mon-Fri",
          alias: "MON_FRI"
        },
        {
          id: 3,
          name: "W",
          alias: "WEEK"
        },
        {
          id: 4,
          name: "M",
          alias: "MONTH"
        },
        {
          id: 5,
          name: "Q",
          alias: "QUAR"
        },
        {
          id: 6,
          name: "H/Y",
          alias: "H_YEAR"
        },
        {
          id: 7,
          name: "E-Y",
          alias: "E_YEAR"
        },
        {
          id: 8,
          name: "AN",
          alias: "ANOUNCE"
        }
      ],
      hover: false,
      selectedRepeatOption: {
        rangeId: null,
        alias: null,
        name: null,
        repeatId: null
      },
      checkRepeatTrue: false,
      hoverCellId: false,
      taskTypeFromEstTime: this.taskType,
      taskSubTypeFromEstTime: this.taskSubType
    };
  },
  methods: {
    getOriginalCreator() {
      let originalCreator = null;
      this.task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.id;
        }
      });
      return originalCreator;
    },
    disableTimeFrame(task) {
      if (task) {
        if (this.auth.user.id === this.getOriginalCreator()) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    once() {},
    clearRepeatOption() {
      this.selectedRepeatOption = {
        rangeId: null,
        alias: null,
        name: null,
        repeatId: null
      };
      this.$emit("reapetOption", this.selectedRepeatOption);
    },
    setTaskType(id) {
      if (id === 1) {
        this.taskTypeFromEstTime = {
          id: 1,
          title: "Task",
          type: "TASK"
        };
      } else if (id === 2) {
        this.taskTypeFromEstTime = {
          id: 2,
          title: "Meeting",
          type: "MEETING"
        };
      } else if (id === 10) {
        this.taskTypeFromEstTime = {
          id: 10,
          title: "Task",
          type: "TASK"
        };
      }
      else if (id === 11) {
          this.taskTypeFromEstTime = {
            id: 11,
            title: "Task",
            type: "TASK"
          }
          //   id: 11,
          //   title: "COMP. EVENT",
          //   type: "COMP. EVENT"
          // };
      }
    },
    setTaskSubType(id) {
      switch (id) {
        case 1:
          if (this.taskTypeFromEstTime.id === 1) {
            this.taskSubTypeFromEstTime = {
              id: 1,
              title: "Task"
            };
          } else if (this.taskTypeFromEstTime.id === 2) {
            this.taskSubTypeFromEstTime = {
              id: 2,
              title: "Meeting"
            };
          }
          // this.taskSubTypeFromEstTime = {
          //   id: 1,
          //   title: "Task"
          // };

          break;
        case 2:
          this.taskSubTypeFromEstTime = {
            id: 2,
            title: "Meeting"
          };
          break;
        case 3:
          this.taskSubTypeFromEstTime = {
            id: 3,
            title: "Outline"
          };
          break;
        case 4:
          this.taskSubTypeFromEstTime = {
            id: 4,
            title: "Announcement"
          };
          break;
        case 5:
          this.taskSubTypeFromEstTime = {
            id: 5,
            title: "Open shift"
          };
          break;
        case 6:
          this.taskSubTypeFromEstTime = {
            id: 6,
            title: "Question"
          };
          break;
        case 12:
          this.taskSubTypeFromEstTime = {
            id: 12,
            title: "COMP. Event"
          };
          break;
      }
      this.$emit("changeTaskSubType", this.taskSubTypeFromEstTime);
    },
    selectRepeatOption(name, rangeId, optAlias, rangeTitle, event, repeatId) {
      if (event.target.checked) {
        this.selectedRepeatOption.name = name;
        this.selectedRepeatOption.rangeId = rangeId;
        this.selectedRepeatOption.alias = optAlias;
        this.selectedRepeatOption.repeatId = repeatId;
        this.changeEstTimeFromCheckbox(rangeTitle);
      } else {
        this.selectedRepeatOption = {
          rangeId: null,
          alias: null,
          name: null,
          repeatId: null
        };
      }
      this.$emit("reapetOption", this.selectedRepeatOption);
    },
    changeEndTaskTime() {
      switch (this.estimatedTime) {
        case "COMP. EVENT":
          this.taskDate.endDate = this.taskDate.startDate;
          this.taskDate.endTime = this.taskDate.startTime;
          this.setTaskType(11);
          this.setTaskSubType(12);
          this.$emit("reapetOption", this.selectedRepeatOption);
          this.$emit("outLineTaskDateTime");

          break;
        case "OUTLINE":
          this.taskDate.endDate = this.taskDate.startDate;
          this.taskDate.endTime = this.taskDate.startTime;
          this.setTaskType(10);
          this.setTaskSubType(3);
          this.$emit("reapetOption", this.selectedRepeatOption);
          this.$emit("outLineTaskDateTime");

          break;
        case "QUESTION":
          this.taskDate.endDate = this.taskDate.startDate;
          this.taskDate.endTime = this.taskDate.startTime;
          this.setTaskType(1);
          this.setTaskSubType(6);

          this.selectedRepeatOption = {
            rangeId: 27,
            alias: "QUESTION",
            name: "QUE",
            repeatId: 10
          };
          this.$emit("reapetOption", this.selectedRepeatOption);

          break;
        case "OPEN SHIFT":
          this.taskDate.endDate = this.taskDate.startDate;
          this.taskDate.endTime = this.taskDate.startTime;
          this.selectedRepeatOption = {
            rangeId: 23,
            alias: "OP-SHFT",
            name: "OS",
            repeatId: 9
          };
          this.setTaskType(1);
          this.setTaskSubType(5);

          this.$emit("reapetOption", this.selectedRepeatOption);
          break;
        case "ANNOUNCEMENT":
          this.taskDate.endDate = this.taskDate.startDate;
          this.taskDate.endTime = this.taskDate.startTime;
          this.selectedRepeatOption = {
            rangeId: 23,
            alias: "AN",
            name: "AN",
            repeatId: 8
          };
          this.setTaskType(1);
          this.setTaskSubType(4);

          this.$emit("reapetOption", this.selectedRepeatOption);
          break;

        case "15 minutes":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            15,
            "minutes"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "30 minutes":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            30,
            "minutes"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "1 hour":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            60,
            "minutes"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "2 hours":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            120,
            "minutes"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "3 hours":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            180,
            "minutes"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "6 hours":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            6,
            "hours"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "9 hours":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            9,
            "hours"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "12 hours":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            12,
            "hours"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "15 hours":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            15,
            "hours"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "1 day":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            1,
            "day"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "2 days":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            2,
            "days"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "3 days":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            3,
            "days"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "week":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            1,
            "week"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "2 weeks":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            2,
            "weeks"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;

        case "month":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            1,
            "month"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "2 month":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            2,
            "months"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "3 month":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            3,
            "months"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "Half a year":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            6,
            "months"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "9 month":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            9,
            "months"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "Year":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            1,
            "year"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "Year and half":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            1.5,
            "year"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "2 years":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            2,
            "years"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "3 years":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            3,
            "years"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        case "5 years":
          this.setEndTime(
            moment(this.taskDate.startDate)
              .hours(this.taskDate.startTime.slice(0, 2))
              .minutes(this.taskDate.startTime.slice(3, 5)),
            5,
            "years"
          );
          // this.setTaskType(1);
          this.clearRepeatOption();
          this.setTaskSubType(1);

          break;
        default:
        // code block
      }
    },

    onInput(event) {
      if (typeof event == "string") {
        this.$nextTick(() => {
          this.newValue = event;
        });
      } else if (typeof event == "object") {
        this.$nextTick(() => {
          this.newValue = event.target.value;
        });
      }

      // this.newValue = event;
      // this.newValue = event.target.value;

      // });
    },
    changeEstTime(event, rangeId) {
      this.selectedRepeatOption.rangeId = rangeId;
      this.estimatedTime = event.target.innerText;
      this.$emit("addEstTimeTag", this.estimatedTime);
      this.changeEndTaskTime();
    },
    changeEstTimeFromCheckbox(e) {
      this.estimatedTime = e;
      this.changeEndTaskTime();
    },
    getStartTime() {
      let start = moment();
      let remainder = start.minute() % 15;
      let dateTime;
      if (remainder < 7) {
        dateTime = moment(start)
          .subtract(remainder, "minutes")
          .format();
      } else {
        remainder = 15 - (start.minute() % 15);
        dateTime = moment(start)
          .add(remainder, "minutes")
          .format();
      }

      return moment(dateTime)
        .format()
        .slice(11, 19);
    },

    setEndTime(date, amount, unit) {
      let tempDate = moment(date).add(amount, unit);
      this.getEndTime(tempDate);
      this.taskDate.endDate = moment(tempDate).format("YYYY-MM-DD");
    },
    getEndTime(estimate) {
      if (estimate === undefined) {
        // let end = moment(this.taskDate.endTime);
        let end = moment();
        let remainderEnd = end.minute() % 15;
        let dateTimeEnd;
        if (remainderEnd < 7) {
          dateTimeEnd = moment(end)
            .subtract(remainderEnd, "minutes")
            .format();
        } else {
          remainderEnd = 15 - (end.minute() % 15);
          dateTimeEnd = moment(end)
            .add(remainderEnd, "minutes")
            .format();
        }
        return moment(dateTimeEnd)
          .add(3, "hours")
          .format()
          .slice(11, 19);
      } else {
        let end = estimate;
        let remainderEnd = end.minute() % 15;
        let dateTimeEnd;
        if (remainderEnd < 7) {
          dateTimeEnd = moment(end)
            .subtract(remainderEnd, "minutes")
            .format();
        } else {
          remainderEnd = 15 - (end.minute() % 15);
          dateTimeEnd = moment(end)
            .add(remainderEnd, "minutes")
            .format();
        }
        this.taskDate.endTime = moment(dateTimeEnd)
          .format()
          .slice(11, 19);
      }
    },

    getTimeFromTask(time) {
      let temp = moment(time).format("HH") + ":" + moment(time).format("mm");
      return temp;
    },
    changeEndTime(event) {
      this.taskDate.startDate = event.target.value;

      this.taskDate.endDate = event.target.value;
      // this.changeEndTaskTime()
    },
    calendarTabIsActive() {
      let x = this.estimatedTime;
      this.$emit("changeActiveTaskTab", { tab: "CAL", estTime: x });
    },
    getEstTimeTitle(estimatedTime) {
      switch (estimatedTime) {
        case null:
          this.estimatedTime = this.task.task_sub_type.title.toUpperCase();
          break;
        case 0.25:
          this.estimatedTime = "15 minutes";
          break;
        case 0.5:
          this.estimatedTime = "30 minutes";
          break;
        case 1:
          this.estimatedTime = "1 hour";
          break;
        case 2:
          this.estimatedTime = "2 hours";
          break;
        case 3:
          this.estimatedTime = "3 hours";
          break;
        case 6:
          this.estimatedTime = "6 hours";
          break;
        case 9:
          this.estimatedTime = "9 hours";
          break;
        case 12:
          this.estimatedTime = "12 hours";
          break;
        case 15:
          this.estimatedTime = "15 hours";
          break;
        case 24:
          this.estimatedTime = "1 day";
          break;
        case 48:
          this.estimatedTime = "2 days";
          break;
        case 72:
          this.estimatedTime = "3 days";
          break;
        case 168:
          this.estimatedTime = "week";
          break;
        case 336:
          this.estimatedTime = "2 weeks";
          break;
        case 720:
          this.estimatedTime = "month";
          break;
        case 1440:
          this.estimatedTime = "2 month";
          break;
        case 2160:
          this.estimatedTime = "3 month";
          break;
        case 4320:
          this.estimatedTime = "Half a year";
          break;
        case 6480:
          this.estimatedTime = "9 month";
          break;
        case 8640:
          this.estimatedTime = "Year";
          break;
        case 12960:
          this.estimatedTime = "Year and half";
          break;
        case 17280:
          this.estimatedTime = "2 years";
          break;
        case 25920:
          this.estimatedTime = "3 years";
          break;
        case 43200:
          this.estimatedTime = "5 years";
          break;
        default:
          this.estimatedTime = "OUTLINE";
      }
    }
  },
  mounted() {
    // starts dropdown from bottom
    $(".dropdown-toggle-split").on("click", function() {
      $(".dropdown-menu").animate({ scrollTop: 9999 }, "fast");
    });
    if (this.task) {
      this.getEstTimeTitle(this.task.time_quantity);
    }
    this.$emit("setTaskDate", {
      taskDate: this.taskDate,
      estTime: this.estimatedTime
    });
    this.$emit("addEstTimeTag", this.estimatedTime);
  },
  watch: {
    // taskDate: function() {
    //   this.$emit("setTaskDate", {
    //     taskDate: this.taskDate,
    //     estTime: this.estimatedTime
    //   });
    //   // this.$emit("changeActiveDateForCalendar", this.taskDate);
    // },
    taskType() {
      this.taskTypeFromEstTime = this.taskType;
    },
    taskSubType() {
      this.taskSubTypeFromEstTime = this.taskType;
    },
    taskTypeFromEstTime() {
      this.$emit("changeTaskType", this.taskTypeFromEstTime);
    },
    taskSubTypeFromEstTime() {
      // this.$emit("changeTaskSubType", this.taskSubTypeFromEstTime);
    },
    changeEstTimeTitle: function() {
      if (this.changeEstTimeTitle.length > 0) {
        this.estimatedTime = this.changeEstTimeTitle;
      }
    },
    taskDate: {
      handler(taskDate) {
        this.$emit("setTaskDate", {
          taskDate: this.taskDate,
          estTime: this.estimatedTime
        });
      },
      deep: true
    }

    // "taskDate.endTime": function() {
    //
    //   this.$emit("setTaskDate", {
    //     taskDate: this.taskDate,
    //     estTime: this.estimatedTime
    //   });
    //   // this.$emit("changeActiveDateForCalendar", this.taskDate);
    // }
  }
};
</script>

<style scoped lang="scss">
.col-date-line-item {
  /*width: 20%;*/
  /*margin-right: 5px;*/
  /*display: inline-flex;*/
  margin-right: -43px;
}
.col-select-line-item {
  margin-right: -50px;
  width: 25%;
  /* margin-right: 5px; */
  /* display: inline-flex; */
  margin-left: 22px;
}
/*.time-line-item {*/
/*  width: 17%;*/
/*  margin-right: 5px;*/
/*  display: inline-flex;*/
/*}*/

$ease: cubic-bezier(0.2, 1, 0.3, 1);

.wrapper {
  display: inline;
  transform: translate(-50%, -50%);
  width: 10%;
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 5px;

  svg {
    width: 30px;
    height: auto;
    margin-bottom: -10px;
    cursor: pointer;
    overflow: visible;
    polygon,
    path {
      transition: all 0.5s $ease;
    }
    &:hover polygon,
    &:hover path {
      transition: all 1s $ease;
      fill: #44a2d2;
    }

    &:hover .arrow {
      animation: arrow-anim 2.5s $ease infinite;
    }
    &:hover .arrow-fixed {
      animation: arrow-fixed-anim 2.5s $ease infinite;
    }
  }
}

@keyframes arrow-anim {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  5% {
    transform: translateX(-0.1rem);
  }
  100% {
    transform: translateX(1rem);
    opacity: 0;
  }
}

@keyframes arrow-fixed-anim {
  5% {
    opacity: 0;
  }
  20% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.dropdown-menu {
  min-width: 231px;
  max-height: 709px;
  overflow: auto;
}
.dropdown-item {
  display: flex;
  min-width: 100%;
}

.estimated-time-button {
  width: 100%;
}
/*
    input.date-line-item {
      position: relative;
      width: 150px;
      height: 36px;
      color: white;
      margin-bottom: -14px;
    }

    input.date-line-item:before {
      position: absolute;
      top: 3px; left: 3px;
      content: attr(data-date);
      display: inline-block;
      color: black;
      line-height: 29px!important;
    }

    input.date-line-item::-webkit-datetime-edit, input::-webkit-inner-spin-button, input::-webkit-clear-button {
      display: none;
    }

    input.date-line-item::-webkit-calendar-picker-indicator {
      position: absolute;
      top: 3px;
      right: 0;
      color: black;
      opacity: 1;
    }
    */

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none !important;
  -webkit-appearance: none !important;
  margin: 0 !important;
}

input[type="date"]::-webkit-clear-button {
  display: none;
  -webkit-appearance: none;
}
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/*#dateInput:not([value])::-webkit-datetime-edit-fields-wrapper,*/
/*#dateInput[value=""]::-webkit-datetime-edit-fields-wrapper {*/
/*  visibility: hidden;*/
/*}*/

/*input[type="date"]::-webkit-datetime-edit-month-field {*/
/*    color: red;*/
/*  }*/

/*  &::-webkit-datetime-edit-day-field {*/
/*    color: white;*/
/*  }*/
/*  &::-webkit-datetime-edit-year-field {*/
/*    color: blue;*/
/*  }*/

/*  &::-webkit-clear-button {*/
/*    font-size: 18px;*/
/*    height: 30px;*/
/*    position: relative;*/
/*    right: 5px;*/
/*    margin-right: 4px;*/
/*  }*/
/*  &::-webkit-inner-spin-button {*/
/*    height: 30px;*/
/*  }*/
/*  &::-webkit-calendar-picker-indicator {*/
/*    font-size: 18px;*/

/*    &:hover {*/
/*      background-color: lighten(#2f2f2f,40%);*/
/*      color: darken(#fff, 10%);*/
/*      cursor: pointer;*/
/*    }*/
/*    &:active {*/
/*      color: blue;*/
/*    }*/
/*  }*/
/*}*/
.repeat-options {
  font-size: 10px;
  display: contents;
}
.repeat-options label:before {
  vertical-align: middle;
  position: relative;
}
.item-checkbox {
  width: 10px;
  margin-right: 2px;
}
.time-group {
  display: flex;
  justify-content: space-around;
}
.linked {
  border: none;
}
.option-container {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.date-rep-button {
  /*min-width: 121px;*/
  min-width: 80px;
  font-size: 10px;
  min-height: 34px;
  padding: 1px;
}
input.form-control.date-line-item {
  padding-left: 3px;
  padding-right: 0px;
  width: 84%;
}
.date-time-short-row,
.mini-date-col {
  margin: 0px;
  padding: 0px;
}
.mini-task-date-input {
  padding: 0px;
  padding-left: 3px;
  font-size: 11px;
  /*width: 80%;*/
}
.mini-date-col-start,
.mini-date-col-end {
  width: 80px;
}
.col-sm-2.mini-task-position-col {
  width: 85px;
}
.mini-date-col-est {
  width: 80px;
}
.frozen {
  opacity: 0.5;
  pointer-events: none;
}
</style>
